// import * as actionCreators from "../../../store/actionCreators/index";
import { useEffect, useState } from 'react';
import Icon from '../../../component/Icon';
import Table from '../../../component/Table/Table';
import { Link, useNavigate } from 'react-router-dom';
import { axiosInstance as axios } from '../../../axios/axios';
import { useSelector, useDispatch } from 'react-redux';
import TableActionBtn from '../../../component/Table/TableActionButton/TableActionButton';
import * as actionCreators from '../../../store/actionCreators/index';
import * as Action from '../../../store/actions';

function Products() {
  const dispatch = useDispatch();
  const state = useSelector((state) => state.product);
  const [totalPage, setTotalPage] = useState(1);
  const [productLimit, setProductLimit] = useState(1);
  const [loading, setLoading] = useState(false);
  const [page, setPage] = useState(1);
  const navigate = useNavigate();

  useEffect(() => {
    (async () => {
      try {
        dispatch({ type: Action.GET_ADMIN_PRODUCTS, payload: [] });

        const res = await axios.get(
          `/api/dashboard/products?page=${page}&limit=5`
        );
        dispatch({ type: Action.GET_ADMIN_PRODUCTS, payload: res.data.data });
        setProductLimit(res.data.meta.per_page);
        setTotalPage(res.data.meta.total);
      } catch (err) {
        console.log(err.message);
        dispatch({ type: Action.GET_ADMIN_PRODUCTS, payload: [] });
      }
    })();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [page]);

  const viewProduct = (data) => {
    dispatch({ type: Action.SELECT_ADMIN_PRODUCT, payload: data });
    navigate(data.id);
  };
  const editProduct = (data) => {
    dispatch({ type: Action.SELECT_ADMIN_PRODUCT, payload: data });

    navigate(`/admin/products/edit/${data.id}`);
  };
  const deleteProduct = (data) => {
    dispatch(actionCreators.deleteProduct(data.id, setLoading));
  };

  const tableHead = [
    'Product id',
    'Category',
    'Title',
    'Description',
    'Price',
    'Action',
  ];
  let data;
  if (state.backend.productList && state.backend.productList.length !== 0) {
    data = state.backend.productList.map((el) => {
      return [
        `# ${el.id}`,

        `# ${el.title}`,

        el.title,
        el.description.slice(0, 50) + ' ...',
        `Rs ${el.price}`,
        <TableActionBtn
          clickedView={() => viewProduct(el)}
          clickedEdit={() => editProduct(el)}
          clickedDelete={() => deleteProduct(el)}
          display={['view', 'edit', 'delete']}
        />,
      ];
    });
  }
  return (
    <div className='px-12'>
      <h2 className='text-greySecondary mb-8 font-[500] text-3xl'>Products</h2>
      {/* PRODUCT FILTER TAB */}
      <div className='flex justify-between items-center border-b-4 pb-2'>
        <h2 className='text-greySecondary cursor-pointer text-lg'>
          Main Course
        </h2>
        <h2 className='text-greySecondary cursor-pointer text-lg'>Appetizer</h2>
        <h2 className='text-greySecondary cursor-pointer text-lg'>Dessert</h2>
        <h2 className='text-greySecondary cursor-pointer text-lg'>Soup</h2>
        <h2 className='text-greySecondary cursor-pointer text-lg'>Grill</h2>
        <button className='flex gap-1 items-center bg-greySecondary p-2 rounded-lg'>
          <Icon name='settings' className='w-4 h-4 fill-white' />
          <p className='text-white font-[600] text-sm'>Filter</p>
        </button>
      </div>

      {/* ADD */}
      <div className='flex justify-between my-4'>
        <h2 className='font-[600] text-greyPrimary'>Choose Main Course</h2>
        <Link
          to='add'
          className='flex gap-1 bg-greyPrimary rounded-md p-2 text-white text-sm font-[600] items-center'
        >
          <div className='w-5 h-5 flex items-center rounded-full justify-center bg-white '>
            <Icon name='plus' className='w-4 h-4 fill-greyPrimary' />
          </div>
          <h2>Add New Product</h2>
        </Link>
      </div>

      {/* TABLE */}
      <div className='mt-4'>
        <Table
          tableHead={tableHead}
          tableData={data}
          page={page}
          setPage={setPage}
          totalPage={totalPage}
          productLimit={productLimit}
        />
      </div>
    </div>
  );
}
export function TableActionBtnProduct(props) {
  return (
    <div className='flex gap-2'>
      <Link to={props.view}>
        <button
          onClick={props.clickedView}
          className='w-8 h-8 bg-blue-400 hover:opacity-80 flex justify-center items-center rounded-md'
        >
          <Icon name='eye-solid' className='w-[1rem] h-[1rem] fill-white' />
        </button>
      </Link>

      <Link to={props.edit}>
        <button
          onClick={props.clickedEdit}
          className='w-8 h-8 bg-green-400 hover:opacity-80 flex justify-center items-center rounded-md'
        >
          <Icon name='edit' className='w-[1rem] h-[1rem] fill-white' />
        </button>
      </Link>

      <button
        onClick={props.clickedDelete}
        className='w-8 h-8 bg-red-400 hover:opacity-80 flex justify-center items-center rounded-md'
      >
        <Icon name='deleteBin' className='w-[1rem] h-[1rem] fill-white' />
      </button>
    </div>
  );
}

export default Products;
